package com.downdogapp.client.singleton

import kotlinx.browser.window

actual object UserPrefsHelper : SharedUserPrefsInterface {

  private const val DOWNDOG_KEY_PREFIX = "downdogapp"

  private val localStorage get() = window.localStorage

  actual fun getString(key: String) = localStorage.getItem("$DOWNDOG_KEY_PREFIX-$key")

  actual fun getDouble(key: String) = getString(key)?.toDoubleOrNull()

  actual fun getInt(key: String): Int? = getString(key)?.toIntOrNull()

  actual fun getLong(key: String): Long? = getString(key)?.toLongOrNull()

  actual fun getBoolean(key: String): Boolean? = when (getString(key)) {
    "true" -> true
    "false" -> false
    else -> null
  }

  actual operator fun set(key: String, string: String?) = setString(key, string)

  actual operator fun set(key: String, double: Double) = setString(key, double.toString())

  actual operator fun set(key: String, int: Int) = setString(key, int.toString())

  actual operator fun set(key: String, long: Long) = setString(key, long.toString())

  actual operator fun set(key: String, boolean: Boolean) = setString(key, boolean.toString())

  private fun setString(keyName: String, string: String?) {
    string?.let {
      localStorage.setItem("$DOWNDOG_KEY_PREFIX-$keyName", it)
    }
  }

  actual fun remove(key: String) = localStorage.removeItem("$DOWNDOG_KEY_PREFIX-$key")

  override fun clear() {
    (0..<localStorage.length)
      .map { localStorage.key(it) }
      .filter { key -> key != null && key.contains(DOWNDOG_KEY_PREFIX) }
      .forEach {
        localStorage.removeItem(it!!)
      }
  }
}
